export const ORDER_COMPLAINT_LIST_PAGE_PATH = '/complaint/list'
